export default {
  buttons: {
    start: 'Begin met bereiden van geplande bestelling',
  },
};
